import { Box } from "@radix-ui/themes";

export default function ItemsCounter({ currentItemsCount, totalItemsCount }: { currentItemsCount?: number; totalItemsCount?: number }) {
    return (
        <Box className="fixed bottom-3 right-3 bg-att-cobalt-blue text-white p-2 rounded-[4px] opacity-75 hover:opacity-100">
            Showing {currentItemsCount} of {totalItemsCount} items
        </Box>
    );
}
